export default {
  places: state => state.places,
  filteredPlaces(state, _, rootState) {
    if (rootState.app.searchString) {
      return state.places.filter(item => {
        return rootState.app.searchString
          .toLowerCase()
          .split(' ')
          .every(v => item.Name.toLowerCase().includes(v))
      })
    }
    return state.places
  },
  ownedPlaces: state => state.ownedPlaces,
  place: state => state.place,
  totalSpots: state => state.totalSpots,
  availableSpots: state => state.availableSpots,
  sessions: state => state.sessions,
  controllers: state => state.controllers,
  loadingControllers: state => state.loadingControllers,
  refreshingControllers: state => state.refreshingControllers,
  controllerLogs: state => state.controllerLogs,
  selectedController: state => state.selectedController,
  openingOrClosingGate: state => state.openingOrClosingGate,
  controllerFirmwareList: state => state.controllerFirmwareList,
  carWashDisputes: state => state.carWashDisputes
}
